/**
 * SEO Data Configuration for All Pages
 * Optimized for Search Engines and AI Crawlers
 */

const baseUrl = 'https://bilalganjautoparts.com';

export const seoData = {
  home: {
    title: 'Bilal Ganj Auto Parts - Professional Car Repair & Auto Parts in Pakistan',
    description: 'Leading auto parts supplier and car repair service in Pakistan. Expert mechanics, genuine parts for Toyota, Honda, Suzuki, and all major brands. 10+ years of trusted service.',
    keywords: 'auto parts Pakistan, car repair Pakistan, automotive services, engine repair, brake service, oil change, genuine auto parts, Toyota parts Pakistan, Honda parts Pakistan, Suzuki parts Pakistan, car maintenance, professional mechanics, Bilal Ganj, auto parts Lahore',
    ogImage: '/logo.png',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'AutoRepair',
      name: 'Bilal Ganj Auto Parts',
      image: `${baseUrl}/logo.png`,
      description: 'Professional auto repair services and genuine auto parts for all major brands in Pakistan',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'PK',
        addressLocality: 'Pakistan',
      },
      priceRange: '$$',
      telephone: '+923017928133',
      url: baseUrl,
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '09:00',
          closes: '21:00',
        },
      ],
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '5000',
        bestRating: '5',
        worstRating: '1',
      },
      areaServed: {
        '@type': 'Country',
        name: 'Pakistan',
      },
      sameAs: [
        'https://www.facebook.com/Auto.carparts.bilaljung.lahore',
        'https://www.instagram.com/bilalganj_parts',
        'https://www.tiktok.com/@bilalganjautoparts',
        'https://www.youtube.com/@bilalganjautoparts',
        'https://whatsapp.com/channel/0029Vagd3wA47Xe9Qkj8X50T',
        'https://g.co/kgs/2HAoiPV',
      ],
    },
  },

  about: {
    title: 'About Us - Bilal Ganj Auto Parts | 10+ Years of Excellence',
    description: 'Learn about Bilal Ganj Auto Parts - Pakistan\'s trusted name in automotive services. Over 10 years of experience providing quality auto parts and expert car repairs for all major brands.',
    keywords: 'about Bilal Ganj, auto parts company Pakistan, car repair history, automotive expertise, professional mechanics team, genuine parts supplier',
    ogImage: '/images/bilalceo.jpg',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: 'About Bilal Ganj Auto Parts',
      description: 'Professional automotive service provider with 10+ years of experience in Pakistan',
      mainEntity: {
        '@type': 'Organization',
        name: 'Bilal Ganj Auto Parts',
        url: baseUrl,
        logo: `${baseUrl}/logo.png`,
        foundingDate: '2013',
        description: 'Leading auto parts and car repair service in Pakistan',
        slogan: 'Quality Parts, Expert Service',
      },
    },
  },

  services: {
    title: 'Auto Repair Services - Engine, Brake, Oil Change & More | Bilal Ganj',
    description: 'Complete auto repair services in Pakistan: Engine repair, brake service, oil change, tire service, transmission repair, AC repair, and more. Expert mechanics, quality guaranteed.',
    keywords: 'car repair services Pakistan, engine repair, brake service, oil change Pakistan, tire service, transmission repair, AC repair, car maintenance, auto diagnostic, vehicle inspection',
    ogImage: '/images/car-service.jpg',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Auto Repair',
      provider: {
        '@type': 'AutoRepair',
        name: 'Bilal Ganj Auto Parts',
        image: `${baseUrl}/logo.png`,
        telephone: '+923017928133',
      },
      areaServed: {
        '@type': 'Country',
        name: 'Pakistan',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Auto Repair Services',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Engine Repair',
              description: 'Professional engine repair and diagnostics',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Brake Service',
              description: 'Complete brake system repair and maintenance',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Oil Change',
              description: 'Professional oil change service',
            },
          },
        ],
      },
    },
  },

  brands: {
    title: 'Auto Parts Brands - Toyota, Honda, Suzuki & More | Bilal Ganj',
    description: 'Genuine auto parts for all major brands: Toyota, Honda, Suzuki, Nissan, Hyundai, Kia, Mazda, Mercedes, BMW, Audi, and more. Original and aftermarket parts available.',
    keywords: 'Toyota parts Pakistan, Honda parts, Suzuki parts, Nissan parts, Hyundai parts, Kia parts, genuine auto parts, OEM parts, aftermarket parts, car brands Pakistan',
    ogImage: '/logo.png',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Auto Parts Brands',
      description: 'Genuine auto parts for all major automotive brands',
      about: {
        '@type': 'ItemList',
        itemListElement: [
          { '@type': 'Brand', name: 'Toyota' },
          { '@type': 'Brand', name: 'Honda' },
          { '@type': 'Brand', name: 'Suzuki' },
          { '@type': 'Brand', name: 'Nissan' },
          { '@type': 'Brand', name: 'Hyundai' },
        ],
      },
    },
  },

  contact: {
    title: 'Contact Us - Get Auto Parts & Repair Services | Bilal Ganj',
    description: 'Contact Bilal Ganj Auto Parts for quality auto parts and expert car repair services. Call +92 301 7928133 or visit us. Open Mon-Sat, 9 AM - 9 PM.',
    keywords: 'contact auto parts Pakistan, car repair contact, Bilal Ganj location, auto parts phone number, car service booking Pakistan',
    ogImage: '/logo.png',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contact Bilal Ganj Auto Parts',
      description: 'Get in touch with us for auto parts and car repair services',
      mainEntity: {
        '@type': 'AutoRepair',
        name: 'Bilal Ganj Auto Parts',
        telephone: '+923017928133',
        email: 'info@bilalganjautoparts.com',
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'PK',
        },
        openingHoursSpecification: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '09:00',
          closes: '21:00',
        },
      },
    },
  },

  faq: {
    title: 'FAQ - Common Questions About Auto Parts & Repair | Bilal Ganj',
    description: 'Frequently asked questions about auto parts, car repair services, pricing, warranties, and more. Get answers to all your automotive questions.',
    keywords: 'auto parts FAQ, car repair questions, automotive FAQ Pakistan, parts warranty, service pricing',
    ogImage: '/logo.png',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What brands do you carry parts for?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We carry genuine and aftermarket parts for all major brands including Toyota, Honda, Suzuki, Nissan, Hyundai, Kia, and many more.',
          },
        },
        {
          '@type': 'Question',
          name: 'Do you provide warranty on parts?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, all our genuine parts come with manufacturer warranty. Aftermarket parts also have warranty coverage.',
          },
        },
        {
          '@type': 'Question',
          name: 'What are your service hours?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We are open Monday to Saturday from 9:00 AM to 9:00 PM. Closed on Sundays.',
          },
        },
      ],
    },
  },
};

export default seoData;